import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';

export type GetPlantUptimeStatusResponse = {
  '-1': number;
  '0': number;
  '1': number;
  time: string;
}[];

export const useGetPlantUptimeStatusQuery = ({
  plantId,
  enabled = false,
}: {
  plantId: string | undefined;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ['plants', plantId, 'uptime'],
    queryFn: async () => {
      const { data } = await client.get<{ body: GetPlantUptimeStatusResponse }>(
        `/plants/${plantId}/uptime`,
        {
          params: {
            metrics: 'uptime',
          },
        }
      );

      return data.body;
    },
    retry: 1,
    staleTime: 1000 * 60,
    enabled,
  });
};
